import React from 'react';

import { Box, CircularProgress } from '@mui/material';

export const CircleLoading = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: '20px',
            }}
        >
            <CircularProgress />
        </Box>
    );
};
